import { render, staticRenderFns } from "./LeftMenu.vue?vue&type=template&id=4272edf6&scoped=true&"
import script from "./LeftMenu.js?vue&type=script&lang=js&"
export * from "./LeftMenu.js?vue&type=script&lang=js&"
import style0 from "./LeftMenu.vue?vue&type=style&index=0&id=4272edf6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4272edf6",
  null
  
)

export default component.exports